define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        let moduleTeam = function (id) {

            var name = 'module-tv-layout-team(' + id + ')';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.tvLayoutContentSubheaderCls, 'animate__slideInDown', 'tv-' + view.publicVars.slug, {});

                $(view.publicVars.cssId.anim.tvLayoutTeamBoxItemCls).each(function (key, item) {
                    const id = container.getData($(item)[0], 'id');
                    scroll.registerAnimatedElement('#' + view.publicVars.cssId.anim.tvLayoutTeamBoxItemCls .substr(1) + id, 'animate__zoomIn',
                        'tv-' + view.publicVars.slug, {});
                });

            };

            view.bind = function () {

            };

            view.methods = {
                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        };

        var factory = {
            objId: 0,
            /**
             * Get new team object
             */
            create: function () {
                factory.objId++;

                var obj = moduleTeam(factory.objId);

                return obj;
            }
        };

        return {
            create: factory.create
        }

    });